import React, { useState } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import quicktixlogo from "../../../Images/GX_Logo_Black_No_Bg.png";
import { Input, notification } from "antd";
import { useResetPasswordMutation } from "../../../Redux/Slices/Accounts/AccountsapiSlice";
import { useLocation, useNavigate } from "react-router-dom";
import QuickTixLogo from "../../../Images/GX_Logo_White_No_Bg.png";

const NewPassword = () => {
  const [resetPassword] = useResetPasswordMutation();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const email = new URLSearchParams(location.search).get("email");

  const handlePasswordChange = (e, type) => {
    const value = e.target.value;

    if (type === "new") {
      setNewPassword(value);
      if (confirmPassword && value !== confirmPassword) {
        setPasswordError("Passwords do not match!");
      } else {
        setPasswordError("");
      }
    } else {
      setConfirmPassword(value);
      if (newPassword && value !== newPassword) {
        setPasswordError("Passwords do not match!");
      } else {
        setPasswordError("");
      }
    }
  };

  const handleResetPassword = async () => {
    if (newPassword.length < 8) {
      notification.error({
        message: "Password must be at least 8 characters long!",
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      notification.error({
        message: "Passwords do not match!",
      });
      return;
    }

    try {
      const response = await resetPassword({
        newPassword,
        confirmPassword,
        email,
      }).unwrap();
      if (response.success) {
        notification.success({
          message: "Password reset successfully!",
        });

        navigate(`/login`);
      }
    } catch (err) {
      console.error("Failed to reset password: ", err.data.message);
      let message = err.data.message;
      notification.error({
        message: message,
      });
    }
  };

  return (
    <>
    <Box
        sx={{
          backgroundColor: "black",
          width: "100%",
          height: "80px", // Adjust height as needed
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "fixed", // Use 'fixed' if you want it to stay on scroll
          top: 0,
          left: 0,
        }}
        textAlign="center"
      >
        <img
          src={QuickTixLogo}
          alt="GX Tickets"
          style={{ height: "75px", cursor: "pointer" }}
          onClick={() => navigate("/")}
        />
      </Box>

      <Grid p={5}>
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={11} md={6} lg={4}>
            <Box textAlign="justify"
              hyphens={"auto"}
              display={"flex"}
              flexDirection={"column"}
              gap={2}
              pt={15}>
              <Typography variant="h4" gutterBottom sx={{ textAlign: "center", mb: 2}}>
                Create New Password
              </Typography>
              <Typography variant="body1" gutterBottom>
                Please enter and confirm your new password. You will need to
                login after you reset.
              </Typography>

              <Box sx={{ textAlign: "left", mt: 2 }}>
                <Typography>Enter New Password</Typography>
                <Input.Password
                  size="large"
                  placeholder="New Password"
                  value={newPassword}
                  onChange={(e) => handlePasswordChange(e, "new")}
                />
                {passwordError && (
                  <Typography color="red" sx={{ mt: 1 }}>
                    {passwordError}
                  </Typography>
                )}
              </Box>

              <Box sx={{ textAlign: "left", mt: 2 }}>
                <Typography>Enter Confirm Password</Typography>
                <Input.Password
                  size="large"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => handlePasswordChange(e, "confirm")}
                />
                {passwordError && (
                  <Typography variant="body2" color="red">
                    {passwordError}
                  </Typography>
                )}
              </Box>

              <Box sx={{ mt: 2 }}>
                <Button
                  variant="outlined"
                  sx={{
                    mt: 2,
                    width: "100%",
                    textTransform: "none",
                    backgroundColor: "var(--primary-color)",
                    borderRadius: 20,
                    color: "white",
                    outline: "none",
                    border: "none",
                    "&:hover": {
                      color: "grey",
                      backgroundColor: "white",
                      border:"1px solid black",
                      outline: "none",
                    },
                  }}
                  onClick={handleResetPassword}
                >
                  Reset Password
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default NewPassword;
